import { InjectionToken } from '@angular/core';

export const CB_APP_CONFIG = new InjectionToken<any>('CB_APP_CONFIG');
